module.exports = __webpack_public_path__ + "img/Butterfly_00319.70baa507.png";